module.exports = __webpack_public_path__ + "img/ku.c712aa84.svg";